import { useStore } from "../../context/StoreContext";
import { LOGO } from "../../lib/api";

export const Logo = ({ alt = "Vacation Apparel logo", ...props }) => {
  const { settings } = useStore();
  return <img src={settings?.logo_url || LOGO} alt={alt} {...props} data-testid={props["data-testid"] || "brand-logo"} />;
};
